import Application from "../../Application";
import ReportingPeriodDetailsPresenter, {
  IReportingPeriodDetailsPresenter
} from "../../presenter/reporting/ReportingPeriodDetailsPresenter";
import { INotificationService } from "../../service/notification/NotificationService";
import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class ShowReportingPeriodDetailsInteractor {
  private application: Application;
  private output?: IReportingPeriodDetailsPresenter;
  private notificationService: INotificationService;
  private reportingPeriodService: IReportingPeriodService;
  private applicantService: IApplicantService;

  constructor(
    application,
    notificationService,
    reportingPeriodService,
    applicantService
  ) {
    this.application = application;
    this.notificationService = notificationService;
    this.reportingPeriodService = reportingPeriodService;
    this.applicantService = applicantService;
  }

  async getReportingPeriod(reportingPeriodId: number) {
    try {
      return this.reportingPeriodService.getReportingPeriod(reportingPeriodId);
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  async getReportingPeriodApplicants(reportingPeriodId: number) {
    try {
      return this.reportingPeriodService.getReportingPeriodApplicants(
        reportingPeriodId
      );
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute(reportingPeriodId: number) {
    this.output = ReportingPeriodDetailsPresenter({
      application: this.application,
      initialState: {
        reportingPeriod: {} as IReportingPeriod,
        reportingPeriodApplicants: []
      }
    });

    this.getReportingPeriod(reportingPeriodId).then(
      (result) =>
        result && this.output && this.output.setReportingPeriod(result)
    );

    this.getReportingPeriodApplicants(reportingPeriodId).then(
      (result) =>
        result &&
        this.output &&
        this.output.setReportingPeriodApplicants(result)
    );

    return this.output;
  }
}
